module.exports = __webpack_public_path__ + "static/media/info-icon.ed9dbaba.svg";